
import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";


class MonitoringQuestionsApi extends baseApi {

    getList = async () => {
        return await this.get('?app=monitoringquestions&act=getList')
    }

}

export default new MonitoringQuestionsApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);
